import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../assets/css/ScrollToExplore.css";

const ScrollToExplore = () => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  // Hide ScrollToExplore on specific routes (normalize to handle basenames/trailing slashes)
  const normalizedPathname =
    location.pathname.toLowerCase().replace(/\/+$/, "") || "/";
  const hiddenRoutes = ["/insights", "/experiences", "/join-us", "/about"];
  const isHiddenRoute = hiddenRoutes.some((route) =>
    normalizedPathname.endsWith(route)
  );

  useEffect(() => {
    const checkVisibility = () => {
      const atTop = window.scrollY < 10; // Allow small scroll amounts
      setIsVisible(atTop);
    };

    // Check initially
    checkVisibility();

    // Check on scroll
    window.addEventListener("scroll", checkVisibility);

    // Check when window resizes
    window.addEventListener("resize", checkVisibility);

    // Check when content changes (using a mutation observer as fallback)
    const observer = new MutationObserver(checkVisibility);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style"],
    });

    return () => {
      window.removeEventListener("scroll", checkVisibility);
      window.removeEventListener("resize", checkVisibility);
      observer.disconnect();
    };
  }, []);

  const scrollToExplore = () => {
    const scrollAmount = window.innerHeight * 0.8; // Scroll 80% of viewport height
    window.scrollTo({
      top: window.scrollY + scrollAmount,
      behavior: "smooth",
    });
  };

  if (!isVisible || isHiddenRoute) return null;

  return (
    <button
      className="scroll-to-explore"
      onClick={scrollToExplore}
      aria-label="Scroll to explore more content"
    >
      <span className="scroll-text">Scroll to Explore</span>
      <div className="scroll-icon">
        <div className="scroll-circle"></div>
        <div className="scroll-arrows"></div>
      </div>
    </button>
  );
};

export default ScrollToExplore;
